<div
  class="row subheading-18p tile-color mt-1"
  [innerHTML]="
    'globalrichtext.SwitchToFileUploadContent' | translate | safeHtml
  "
></div>
